import axiosInstance from "./axiosInstance";

const salesService = {
  getAccess: async () => {
    const res = await axiosInstance.get("/admin/sales/access");
    return res.data;
  },

  getTeamPerformance: async (params = {}) => {
    const res = await axiosInstance.get("/admin/sales/performance", { params });
    return res.data;
  },

  getPipelineStages: async () => {
    const res = await axiosInstance.get("/admin/sales/pipeline-stages");
    return res.data;
  },

  getCustomerPool: async (params = {}) => {
    const res = await axiosInstance.get("/admin/sales/customers/pool", { params });
    return res.data;
  },

  getMyCustomers: async (params = {}) => {
    const res = await axiosInstance.get("/admin/sales/customers/mine", { params });
    return res.data;
  },

  getAssignedUnreadTotal: async () => {
    const res = await axiosInstance.get("/admin/sales/customers/unread-total");
    return res.data;
  },

  getTeamCustomers: async (params = {}) => {
    const res = await axiosInstance.get("/admin/sales/customers/team", { params });
    return res.data;
  },

  getSalesAgents: async () => {
    const res = await axiosInstance.get("/admin/sales/agents");
    return res.data;
  },

  getAssignQuota: async (agent_id) => {
    const res = await axiosInstance.get("/admin/sales/assign-quota", {
      params: agent_id ? { agent_id } : {},
    });
    return res.data;
  },

  assignToAgent: async (user_id, agent_id) => {
    const res = await axiosInstance.post("/admin/sales/customers/assign", { user_id, agent_id });
    return res.data;
  },

  assignBulk: async (user_ids, agent_id) => {
    const res = await axiosInstance.post("/admin/sales/customers/assign-bulk", {
      user_ids,
      agent_id,
    });
    return res.data;
  },

  selfAssign: async (user_id) => {
    const res = await axiosInstance.post("/admin/sales/customers/self-assign", { user_id });
    return res.data;
  },

  updateStage: async (assignmentId, stage_id) => {
    const res = await axiosInstance.put(`/admin/sales/customers/${assignmentId}/stage`, { stage_id });
    return res.data;
  },

  reassign: async (assignmentId, agent_id) => {
    const res = await axiosInstance.put(`/admin/sales/customers/${assignmentId}/reassign`, { agent_id });
    return res.data;
  },

  blockCustomer: async (userId, payload) => {
    const res = await axiosInstance.post(`/admin/sales/customers/${userId}/block`, payload);
    return res.data;
  },

  unblockCustomer: async (userId, agent_id) => {
    const res = await axiosInstance.delete(`/admin/sales/customers/${userId}/block`, {
      data: agent_id ? { agent_id } : {},
    });
    return res.data;
  },

  logCall: async (payload) => {
    const res = await axiosInstance.post("/admin/sales/calls/log", payload);
    return res.data;
  },

  getStats: async (params = {}) => {
    const res = await axiosInstance.get("/admin/sales/stats", { params });
    return res.data;
  },

  contactCustomer: async (userId) => {
    const res = await axiosInstance.post(`/admin/sales/customers/${userId}/contact`);
    return res.data;
  },

  getChatMessages: async (userId, params = {}) => {
    const res = await axiosInstance.get(`/admin/sales/customers/${userId}/chat`, { params });
    return res.data;
  },

  markChatSeen: async (userId) => {
    const res = await axiosInstance.post(`/admin/sales/customers/${userId}/chat/mark-seen`);
    return res.data;
  },

  sendChatMessage: async (userId, message) => {
    const res = await axiosInstance.post(`/admin/sales/customers/${userId}/chat/message`, { message });
    return res.data;
  },

  sendChatVoice: async (userId, blob, voiceMeta) => {
    const form = new FormData();
    form.append("file", blob, "voice.webm");
    const waveform = voiceMeta && voiceMeta.waveform;
    if (Array.isArray(waveform) && waveform.length) {
      form.append("voice_waveform", JSON.stringify(waveform));
    }
    if (voiceMeta && voiceMeta.durationMs) {
      form.append("voice_duration_ms", String(voiceMeta.durationMs));
    }
    const res = await axiosInstance.post(`/admin/sales/customers/${userId}/chat/voice`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  },

  sendChatImage: async (userId, file) => {
    const form = new FormData();
    form.append("file", file);
    const res = await axiosInstance.post(`/admin/sales/customers/${userId}/chat/image`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  },

  initiateCall: async (userId, call_type = "voice") => {
    const res = await axiosInstance.post(`/admin/sales/customers/${userId}/call`, { call_type });
    return res.data;
  },

  endCall: async (userId, payload) => {
    const res = await axiosInstance.post(`/admin/sales/customers/${userId}/call/end`, payload);
    return res.data;
  },
};

export default salesService;
